export default function Home() {
  return (
    <div style={{ padding: "25px" }}>
      <h1>Sports Cafe</h1>
    </div>
  );
}
